const access = {
  entities: [], 
  rights: [] 
}

export default access
